<template>
  <div class="row match-height">
    <!-- Statistics Card -->
    <div class="col-xl-12 col-md-12 col-12">
      <div class="card card-statistics">
        <div class="card-header">
          <h4 class="card-title">Users Statistics</h4>
          <div class="d-flex align-items-center">
            <p class="card-text font-small-2 me-25 mb-0"></p>
          </div>
        </div>
        <div class="card-body statistics-body">
          <div class="row">
            <!-- User Statistics -->
            <div class="col-xl-4 col-sm-6 col-12 mb-2" style="margin-bottom: 20px">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ ActiveUsers }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Active Users</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2" style="margin-bottom: 20px">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ userplanData.userwithplan }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Subscribed Users</p>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-6 col-12 mb-2" style="margin-bottom: 20px">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-warn me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ userplanData.userwithnoplan }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Unsubscribed Users</p>
                </div>
              </div>
            </div>
            <!-- End User Statistics -->
            <div class="col-xl-4 col-sm-6 col-12 mb-2">
              <div class="d-flex flex-row">
                <div class="avatar bg-Primary-info me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ businessUser }}</h4>
                  <p class="card-text font-small-3 mb-0">Active Business Users</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2 mb-sm-0">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-info me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ UfamilyPlan }}</h4>
                  <p class="card-text font-small-3 mb-0">Active Family Users</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-info me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ UselfPlan }}</h4>
                  <p class="card-text font-small-3 mb-0">Active Self Users</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-warning me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ inactiveUsers }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Deactivated Users</p>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-6 col-12 mb-2" style="margin-bottom: 20px">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="user"></vue-feather>
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ trialUsers }}</h4>
                  <p class="card-text font-small-3 mb-0">Trial Users</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="mail" />
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ totalMailsSend }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Mail Sent</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="dollar-sign" />
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ fix(debit, 2).toFixed(2) }}</h4>
                  <p class="card-text font-small-3 mb-0">
                    Total Amount Deposit By Client
                  </p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="dollar-sign" />
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ fix(credit, 2).toFixed(2) }}</h4>
                  <p class="card-text font-small-3 mb-0">Total Amount Used By Client</p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-6 col-12 mb-2">
              <div class="d-flex flex-row">
                <div class="avatar bg-light-primary me-2">
                  <div class="avatar-content">
                    <vue-feather type="dollar-sign" />
                  </div>
                </div>
                <div class="my-auto ml-1">
                  <h4 class="fw-bolder mb-0">{{ fix(balance, 2).toFixed(2) }}</h4>
                  <p class="card-text font-small-3 mb-0">Switchmail Balance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-xl-12 col-md-12 col-12">

    </div> -->
    <div class="col-xl-12 col-md-12 col-12">
      <h4 class="mt-1">Monthy Subscription Statistics</h4>
      <canceled-plan-count :dataplan="userplanData"></canceled-plan-count>
      <!-- monthly earnings  -->
      <monthly-earnings></monthly-earnings>
      <!-- end of monthly earning -->
    </div>
    <!--/ Statistics Card -->
    <!-- users table -->
    <div class="col-xl-12 col-md-12 col-12">
      <user-table></user-table>
    </div>
    <!-- end of users table -->
  </div>
</template>
<script>
import CanceledPlanCount from "./layouts/CanceledPlanCount.vue";
import MonthlyEarnings from "./layouts/MonthlyEarnings.vue";
import UserTable from "./UserTable.vue";
import axios from "axios";
import { fix } from "mathjs";

export default {
  components: {
    CanceledPlanCount,
    MonthlyEarnings,
    UserTable,
  },
  setup(props) {
    return {
      fix: fix,
    };
  },
  data() {
    return {
      ActiveUsers: 0,
      inactiveUsers: 0,
      deactivated: 0,
      businessUser: 0,
      clientUser: 0,
      UfamilyPlan: 0,
      UselfPlan: 0,
      UbusinessPlan: 0,
      trialUsers: 0,
      totalMailsSend: 0,
      debit: 0,
      credit: 0,
      balance: 0,
      userplanData: {
        cancelSelf: 0,
        cancelFamily: 0,
        cancelBusiness: 0,
      },
    };
  },
  created() {
    this.getUserCounts();
  },
  mounted() {},
  methods: {
    getUserCounts() {
      const route = this.$router.resolve({
        name: "super-admin-dashboard",
      });
      axios
        .post(route.href)
        .then(({ data }) => {
          this.ActiveUsers = data.data.activeUsers;
          this.inactiveUsers = data.data.inactiveUsers;
          this.businessUser = data.data.businessUser;
          this.clientUser = data.data.clientUser;
          this.UfamilyPlan = data.data.UfamilyPlan;
          this.UselfPlan = data.data.UselfPlan;
          this.userplanData.userwithplan = data.data.userwithplan;
          this.userplanData.userwithnoplan = data.data.userwithnoplan;
          this.userplanData.cancelSelf = data.data.cancelSelf;
          this.userplanData.cancelFamily = data.data.cancelFamily;
          this.userplanData.cancelBusiness = data.data.cancelBusiness;
          this.trialUsers = data.data.trialUsers;
          this.totalMailsSend = data.data.total_mails_send;
          this.debit = data.data.debit;
          this.credit = data.data.credit;
          this.balance = data.data.balance;
        })
        .catch((error) => {
          toastr.error(error.message, "error");
        });
    },
  },
};
</script>
